import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
/**
 * Class description
 *
 * Created: 2017-11-21
 * @author jonas
 */
import {
    IScatterAttentionConfig,
    ScatterAttentionController
} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {Timeline, TimelineLite} from "gsap";
import {TeslaSymbols} from "../../../config/TeslaSymbols";
import {Tesla} from "../../Tesla";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";

export class TeslaScatterAttentionController extends ScatterAttentionController {
    private _hasDimmed:boolean = false;
    private _wasNearWin:boolean = false;

    constructor(index:number, config:IScatterAttentionConfig) {
        super(index, config, false);
    }


    public onReelBounce(data:IReelStoppedData):void {
        if(this.isPossibleToWin(data.reelId)) {
            if(this.getScatterCount(data.reelId) >= 2) {
                this._hasDimmed = true;
                this._wasNearWin = true;
                this.dimSymbols(data.reelId);
            }
        } else {
            Tesla.reelFrame.resetNearWinGaugeAnimation(false);

            if(this._hasDimmed) {
                this.unDimSymbols(data.reelId);
            }
        }

        if(data.reelId == 4) {
            SlotGame.sound.stopEffect(TeslaSoundConfig.instance.REEL_NEAR_WIN);

            this.playFailSound(data);
            this._hasDimmed = false;
        }

        super.onReelBounce(data);
    }

    private playFailSound(data:IReelStoppedData):void {
        if(this._wasNearWin) {
            if(this.getScatterCount(data.reelId) < 3) {
                SlotGame.sound.playEffect(TeslaSoundConfig.instance.REEL_NEAR_WIN_FAIL);
            }
            this._wasNearWin = false;
        }
    }

    private unDimSymbols(reelId:number):void {
        const tl:TimelineLite = new TimelineLite();
        for(let reelIndex:number = 0; reelIndex < reelId; reelIndex++) {
            for(let symbolIndex:number = 0; symbolIndex < 3; symbolIndex++) {
                let symbol:StateReelSymbol = Reels.getSymbol(reelIndex, symbolIndex)!;

                let animation:Timeline | null = symbol.changeState({
                    state : TeslaGameConfig.instance.SYMBOL_STATES.normal,
                    replay : false,
                    prioCheck : false,
                    fadeInDuration : 0.0
                });

                if(animation != null) {
                    tl.add(animation, 0);
                }
            }
        }
    }

    private dimSymbols(reelId:number):void {
        const tl:TimelineLite = new TimelineLite();
        for(let reelIndex:number = 0; reelIndex <= reelId; reelIndex++) {
            for(let symbolIndex:number = 0; symbolIndex < 3; symbolIndex++) {
                let symbol:StateReelSymbol = Reels.getSymbol(reelIndex, symbolIndex)!;
                let animation:Timeline | null;

                if(symbol.symName == TeslaSymbols.S) {
                    animation = symbol.changeState({
                        state : TeslaGameConfig.instance.SYMBOL_STATES.attention,
                        fadeInDuration : 0.0,
                        replay : true
                    });
                } else {
                    animation = symbol.changeState({
                        state : TeslaGameConfig.instance.SYMBOL_STATES.noWin,
                        replay : false,
                        prioCheck : true,
                        fadeInDuration : 0.0
                    });
                }
                if(animation != null) {
                    tl.add(animation, 0);
                }
            }
        }
    }

    protected playAttentionAnimation(data:IReelStoppedData):void {
        const tl:TimelineLite = new TimelineLite();

        Tesla.reelFrame.getNearWinGaugeAnimation(data.reelId);

        for(let reelIndex:number = 0; reelIndex <= data.reelId; reelIndex++) {
            let symbolIndex:number = this._scatterPositions[reelIndex];
            if(symbolIndex < 0) {
                continue;
            }
            let symbol:StateReelSymbol = Reels.getSymbol(reelIndex, symbolIndex)!;

            let animation:Timeline | null = symbol.changeState({
                state : TeslaGameConfig.instance.SYMBOL_STATES.attention,
                fadeInDuration : 0,
                replay : true
            });

            if(animation != null) {
                tl.add(animation, 0);
            }
        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));
    }

    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        const tl:TimelineLite = new TimelineLite();

        Tesla.reelFrame.resetNearWinGaugeAnimation();

        for(let reelIndex:number = 0; reelIndex <= data.reelId; reelIndex++) {
            let symbolIndex:number = this._scatterPositions[reelIndex];
            if(symbolIndex < 0) {
                continue;
            }
            let symbol:StateReelSymbol = Reels.getSymbol(reelIndex, symbolIndex)!;

            let animation:Timeline | null = symbol.changeState({
                state : TeslaGameConfig.instance.SYMBOL_STATES.win,
                fadeInDuration : 0,
                replay : true
            });

            if(animation != null) {
                tl.add(animation, 0);
            }

        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));
    }

    private getScatterCount(reelId:number):number {
        let counter:number = 0;
        // how many scatters landed
        for(let i:number = 0; i <= reelId; i++) {
            if(this._scatterPositions[i] > -1) {
                counter++;
            }
        }
        return counter;
    }
}